<template>

    <div class="manage-booking-access-modal">
        <div class="modal fade" :id="modalId" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">

                    <div class="modal-header opaque-header">
                        <div class="clearfix">
                            <h3 class="modal-title"><strong>Managing access</strong></h3>
                        </div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <div>
                            You can manage access for the selected booking below:
                        </div>


                        <div class="search-form-mask open">
                            <input type="text" class="search-input" v-model="searchInput" v-on:input="filterEmployees" placeholder="Search for..">
                            <input class="search-input__button" />
                            <button class="btn btn-light sb-icon-search">
                                <span class="fa fa-search">
                                    <span class="visually-hidden">Search</span>
                                </span>
                            </button>
                            <button type="reset" class="btn-icon btn-light sb-icon-reset" v-on:click="resetEmployeeFilter">
                                <span class="fa fa-close">
                                    <span class="visually-hidden">reset</span>
                                </span>
                            </button>
                        </div>

                        <div class="clearfix"></div>
                        <div class="select-deselect">
                            <button class="btn btn-link" v-on:click="selectAll">Select all</button>
                            /
                            <button class="btn btn-link" v-on:click="deselectAll">Deselect all</button>
                        </div>

                        <div v-if="isLoadingList" class="list-loading clearfix"><span class="spinner anim-spin"></span> Loading...</div>

                        <table class="employee-access-table">
                            <tbody>
                            <tr v-for="employee in filteredEmployees">
                                <td><strong>{{employee.name}}</strong></td>
                                <td>
                                    <div v-if="isTogglingAccess[employee.id]" class="clearfix"><span class="spinner anim-spin"></span></div>
                                </td>
                                <td style="width: 50px">
                                    <toggle-switch
                                        :value="employee.has_access"
                                        :id="'toggle_' + employee.id"
                                        @input="toggleAccess(employee.id, $event)"/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

    </div>

</template>
<style scoped>
    .list-loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,0.75);

        text-align: center;
        padding-top: 40%;
        z-index: 100;
    }

    .list-loading .spinner {
        vertical-align: middle;
        margin-right: 5px;
    }

    .modal-body {
        position: relative;
    }

    .employee-access-table {
        width: 100%;
    }
</style>
<script>
import Access from "../Services/Access";

export default {

        props: ['bookingId', 'modalId'],

        data: () => { return {
            isLoadingList: false,
            isTogglingAccess: {},
            employees: [],
            filteredEmployees: [],
            searchInput: ""
        }},

        mounted: function() {
            this.refreshAccessList();
        },

        methods: {

            refreshAccessList: function() {

                this.isLoadingList = true;

                Access.fetchForBooking(this.bookingId)
                    .then((employees) => {
                        this.isLoadingList = false;
                        this.employees = employees;
                        this.filteredEmployees = employees;
                    })
                    .catch((err) => {
                        this.isLoadingList = false;
                    })
            },

            filterEmployees: function (event) {
                this.filteredEmployees = this.employees.filter((employee) => {
                    return employee.name.toLowerCase().includes(event.target.value.toLowerCase());
                });

                if (this.filteredEmployees.length < 1) {
                    this.filteredEmployees = [];
                }
            },

            resetEmployeeFilter: function () {
                this.searchInput = "";
                this.filteredEmployees = this.employees;
            },

            toggleAccess: function (employeeID, shouldHaveAccess) {

                if(this.isTogglingAccess[employeeID]) {
                    return;
                }

                this.isTogglingAccess[employeeID] = true;

                Access.toggleForBooking(this.bookingId, employeeID, shouldHaveAccess)
                    .then((data) => {
                        this.isTogglingAccess[employeeID] = false;
                        this.refreshAccessList();
                    }).catch((err) => {
                    this.isTogglingAccess[employeeID] = false;
                });
            },

            selectAll: function () {
                this.toggleAccessForEmployees(this.filteredEmployees, true);
            },

            deselectAll: function () {
                this.toggleAccessForEmployees(this.filteredEmployees, false);
            },

            toggleAccessForEmployees(employees, shouldHaveAccess) {
                let employeeIds = employees.map(employee => employee.id);

                this.isLoadingList = true;

                Access.toggleForBookingEmployees(this.bookingId, employeeIds, shouldHaveAccess).then((data) => {
                    this.isTogglingAccess = {};
                    this.refreshAccessList();
                    this.searchInput = '';
                    this.isLoadingList = false;
                }).catch((err) => {
                    this.isTogglingAccess = {};
                    this.searchInput = '';
                    console.log(err);
                    this.isLoadingList = false;
                });

            }
        },

    }
</script>


<style scoped>
    .search-input {
        position: absolute;
        top: 0;
        right: 0;
        outline: none;
        height: 30px;
        margin: 0;
        z-index: 10;

        font-family: inherit;
        border-radius: 22px;
        color: #babfbf;
        box-shadow: none;
        border: 1px solid #979ca2;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.6;
    }

    .search-input__button {
        background: #fff;
        filter: alpha(opacity=0);
        opacity: 0;
        color: transparent;
        border: none;
        outline: none;
        width: 25px;
    }

    .select-deselect {
        text-align: center;
        margin: 15px;
    }
</style>
